/**
 * Immutable presentation data for one resolved Select option.
 */
export type SelectOptionContent = {
  readonly key: string;
  readonly label: string;
  readonly color: string;
};

/**
 * Renderer-neutral content produced by the Select field module.
 */
export type SelectReadContent = {
  readonly kind: 'select';
  readonly options: readonly SelectOptionContent[];
};

export const EMPTY_SELECT_CONTENT: SelectReadContent = Object.freeze({
  kind: 'select',
  options: Object.freeze([])
});
